import { useOrderState } from '@order/hooks/useOrderState'
import { debugSteps } from '@order/utils/getDebugLog'
import { router } from 'expo-router'
import useSession from 'hooks/useSession'
import Analytics from 'hooks/analytics/Analytics'

const useStartOrder = () => {
  const reset = useOrderState((s) => s.reset)
  const resetDeals = useSession((s) => s.resetDeals)
  const pdType = useOrderState((s) => s.order.pd.current)

  const startConfig = (flowName?: string) => {
    debugSteps.log('startConfig', { flowName })

    // Track order start with PD measurement type
    Analytics.logEvent('order_configuration_start', {
      flow: flowName || 'default',
      pd_type: pdType || 'none',
    })

    reset()

    // For avatar flow, reset deals to avoid any previous deals being used
    // FIXME: We should make this more generic and not depend on the flow name
    if (flowName === 'avatar') {
      resetDeals()
    }

    router.navigate('/frame/select')
  }

  return startConfig
}

export default useStartOrder
